<template>
<div>
    <v-toolbar app color="black" dark>
        <!-- v-toolbar-side-icon
                class="hidden-md-and-up"
                @click="rightDrawerConf = !rightDrawerConf"
            ></v-toolbar-side-icon-->
        <v-toolbar-title data-cy="titleBtn" class="mt-2">
            <img class="menuLogo ml-0 mt-2" src="https://www.icron.it/virtualdrone/assets/images/Logo.png" style="height: 45px" />
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div></div>
        <div>
            <span style="text-align: end; float: right" class="ml-4">
                <v-icon @click="rightDrawerConf = !rightDrawerConf">search</v-icon>
            </span>
            <span v-if="isAdmin() " style="text-align: end; float: right" class="ml-4">
                <v-icon @click="admin()">settings</v-icon>
            </span>
        </div>
        <!--v-btn
                flat
                class="hidden-sm-and-down nav-menu"
                data-cy="menuBtn"
                @click="rightDrawerConf = !rightDrawerConf"
                >Dati attivita'</v-btn
            -->
    </v-toolbar>

    <v-navigation-drawer width="320" :right="right" class="black" dark v-model="rightDrawerConf" :mini-variant="miniVariant" app>
        <v-layout align-center row wrap justify-right class="pa-0 ma-2">
            <v-flex xs12 sm12 md12 lg12>
                <v-btn justify-right icon @click.stop="rightDrawerConf = !rightDrawerConf" slot="activator">
                    <v-icon v-html="
                                rightDrawerConf
                                    ? 'chevron_right'
                                    : 'chevron_left'
                            "></v-icon>
                </v-btn>
            </v-flex>
            <!--div
                    class="mt-2"
                    style="width: 100%; white--text"
                    @click="isAddPoi = true"
                >
                    <span class="white--text">Modifica</span>
                </div-->

            <div class="mt-2">
                <label class="white--text p-2">
                    <p>Partecipanti</p>
                    <v-icon class="white--text mr-2" style="float: right" @click="showAllMarkers()">visibility</v-icon>
                    <v-icon class="white--text mr-2" style="float: right" @click="hideAllMarkers()">visibility_off</v-icon>
                </label>
            </div>

            <div v-for="(partecipante, index) in elencoIscritti" :key="partecipante.id + '' + index" :class="confClass(partecipante)" :style="confStyle(partecipante)">
                <span class="p-2 bg-info mr-2" style="
                            background-color: orange;
                            color: black;
                            padding: 3px;
                            border-radius: 3px;
                        ">{{ partecipante.pett }}</span>
                <small><b>{{ partecipante.cognome }} </b>
                    {{ partecipante.nome }}</small><br />{{ deviceMap[partecipante.deviceid].posIndex  / 1000 }} km. - {{ deviceMap[partecipante.deviceid].passo }}

                <v-icon v-if="partecipante.showMarker" class="white--text" style="float: right" @click="centerTo(partecipante)">mdi-helicopter</v-icon>
                <v-icon v-if="partecipante.showMarker" class="green--text mr-2" style="float: right" @click="showHideMarker(partecipante)">visibility</v-icon>
                <v-icon v-else class="grey--text mr-2" style="float: right" @click="showHideMarker(partecipante)">visibility_off</v-icon>
            </div>
        </v-layout>
    </v-navigation-drawer>
    <v-progress-linear background-color="black" color="orange" class="mt-0 p-0 v-toolbar--fixed" v-model="value" :buffer-value="bufferValue"></v-progress-linear>

    <!--app-navigation></app-navigation -->
    <v-flex v-if="stato == 'replay'" flex xs12 sm12 md12 lg12>
        <v-btn v-if="!pause" round small class="orange black--text" @click="pauseBtn()">Pausa</v-btn>
        <v-btn round small v-if="pause" class="green darken-4 white--text" @click="playBtn()">Play</v-btn>
        <v-btn small class="justify-end" @click="forward(1)">x1</v-btn>
        <v-btn small class="justify-end" @click="forward(5)">x5</v-btn>
        <v-btn small class="justify-end" @click="forward(10)">x10</v-btn>
    </v-flex>
    <v-flex v-if="stato == 'briefing'" flex xs12 sm12 md12 lg12 class="justify-center">
        <h2 center>{{ raceTitle }}</h2>
    </v-flex>
    <v-layout align-top row wrap justify-right class="pa-0 ma-2">
        <v-flex flex xs12 sm12 md12 lg12>
            <map-detail v-if="showMap && showDevice" @clickMarker="clickMarker" @displaySnack="displaySnack" @fromMap="fromMap" :idEvento="idEvento" :bibList="bibList" :moltiplicatore="moltiplicatore" :configuration="configuration" :isAddPoi="isAddPoi" :listaPoi="pois" :settings="configEvento" :participants="elencoIscritti" :deviceMap="deviceMap" :raceTime="raceTime" :raceTitle="raceTitle" :listaRil="listaRil"></map-detail>
        </v-flex>

    </v-layout>
    <v-layout align-top row wrap justify-right class="pa-0 ma-2">
        <v-tabs > 
            <v-tab class="grey darken-4 white--text" activeClass="font-weight-black black--text white" @click="filterTipo('ATLETA')">ATLETI</v-tab>
            <v-tab class="grey darken-4 white--text" activeClass="font-weight-black black--text white" @click="filterTipo('STAFF')">STAFF</v-tab>
            <v-tab class="grey darken-4 white--text" activeClass="font-weight-black black--text orange" @click="filterTipo('WARNING')">WARNING</v-tab>
            <v-tab class="grey darken-4 white--text" activeClass="font-weight-black white--text red" @click="filterTipo('SOS')">SOS</v-tab>
        </v-tabs>
    </v-layout>
    <template>

    </template>

    <v-flex v-if="isAdmin()" flex xs12 sm12 md12 lg12 class="pa-2">
        <v-data-table :items="itemsF" hide-actions class="elevation-2 mb-2">
            <template slot="headers">
                <tr class="black white--text text-uppercase font-weight-black" style="height:20px">
                    <td style="text-align: center;">Stato</td>
                    <td style="text-align: center;">Batt</td>
                    <td style="text-align: center;">Destinatario</td>
                    <td style="text-align: center;">Precisione</td>
                    <td style="text-align: center;">Contatto</td>
                    <td style="text-align: center;">S.O.S.</td>
                    <td style="text-align: center;">Ultima trasmissione</td>
                    <td style="text-align: center;">Posizione</td>
                    <td style="text-align: center;">Velocità</td>
                    <td style="text-align: center;">Device id</td>
                </tr>

            </template>
            <template slot="items" slot-scope="props">
                <tr class="pa-0 ma-0">
                    <td style="height:1px" colspan="3"></td>
                </tr>
                <tr class="pa-1 " style="height:20px">

                    <td width="5%" :class=" getStatusColor(getDeviceProperty(props.item.deviceid, 'status') ) + ' no-wrap pa-2 ma-2'" style="text-align: center;">
                        <v-icon class="white--text mr-2">wifi</v-icon> <strong> {{ getDeviceProperty(props.item.deviceid, "status") }}</strong>
                    </td>

                    <td width="5%" :class=" getBatteryColor(props.item.battery) + ' no-wrap pa-2 ma-2 '" style="text-align: left;">
                        <v-icon class="white--text mr-2">{{ getBatteryStatus(props.item.battery)}}</v-icon> <strong> {{ props.item.battery }} %</strong>
                    </td>
                    <td class="cardUp pa-1" style="">
                        <span class="ml-2 mr-2  pa-1 bib">{{ props.item.pett }}</span><strong>{{ props.item.cognome }} {{ props.item.nome }}
                        </strong>
                    </td>

                    <td width="5%" class=" no-wrap pa-2 ma-2 " style="">
                        <v-icon v-if="props.item.ontrack == 'N'" class="red--text mr-2">warning</v-icon>
                        <v-icon class="black--text mr-2">place</v-icon> {{ props.item.trackdiff }}m.
                    </td>

                    <td class="cardUp pa-1" style="text-align: center;">
                        <span class="">
                            <v-icon class="black--text mr-1">phone</v-icon>{{ props.item.telefono }}
                        </span>
                    </td>
                    <td :class="getSOSColor(props.item.sos)" style="text-align: center;">
                        <strong v-if="props.item.sos == 'Y'">S.O.S.</strong>
                    </td>
                    <td class="cardUp pa-1" style="text-align: center;">
                        {{ props.item.timestamp }}
                    </td>
                    <td class="cardUp pa-1" style="text-align: center;">
                        <strong>Km. {{ props.item.km}}</strong>
                    </td>
                    <td class="cardUp pa-1" style="text-align: center;">
                       {{ props.item.speed}}
                    </td>
                    <td class="cardUp pa-1" style="text-align: center;">
                        {{props.item.deviceid }} -  {{props.item.tipo }}
                    </td>
                </tr>

            </template>
        </v-data-table>
    </v-flex>

    <v-snackbar :timeout="timeout" :vertical="vertical" v-model="showSnack" :color="colorSnack" text :multi-line="multiline">
        {{ messaggioSnack }}
    </v-snackbar>

    <v-footer v-if="isAdmin()" fixed class="p-0 black " style="height: 30px;">
        <v-layout align-start row wrap justify-center class="black p-0 m-0" style="width:100%; ">
            <v-flex flex xs12 sm12 md9 lg9 class="pa-2">
                <table style="width:100%" class="white--text pa-1">
                    <tr>
                        <td :class="  ' no-wrap pa-2 ma-2'" style="text-align: right;">
                            <v-icon class="white--text mr-2">wifi</v-icon> <strong> ONLINE </strong>
                        </td>
                        <td :class=" getStatusColor('ONLINE' ) + ' no-wrap pa-2 ma-2'" style="text-align: center; border-radius: 5px;">
                            <strong> 123 </strong>
                        </td>

                        <td :class="  ' no-wrap pa-2 ma-2'" style="text-align: right;">
                            <v-icon class="white--text mr-2">wifi</v-icon> <strong> OFFLINE </strong>
                        </td>
                        <td :class=" getStatusColor('OFFLINE' ) + ' no-wrap pa-2 ma-2'" style="text-align: center; border-radius: 5px;">
                            <strong> 0 </strong>
                        </td>

                        <td class=" no-wrap pa-2 ma-2 " style="text-align: right;">
                            <v-icon class="white--text  mr-2">place</v-icon>
                            <strong> FUORI TRACCIA </strong>
                        </td>
                        <td class="red white--text no-wrap pa-2 ma-2" style="text-align: center; border-radius: 5px;">
                            <strong> 2 </strong>
                        </td>

                        <td class=" no-wrap pa-2 ma-2 " style="text-align: right;">
                            <v-icon class="white--text mr-2">battery_full</v-icon>
                            <strong> STATO BATTERIE </strong>
                        </td>
                        <td class="no-wrap pa-1" style="text-align: center; border-radius: 5px;">
                            <table style="width:100%" class="white black--text pa-0">
                                <td width="33%" class="red white--text pa-2">
                                    3
                                </td>
                                <td width="33%" class="orange white--text pa-2">
                                    5
                                </td>
                                <td width="33%" class="green white--text pa-2">
                                    25
                                </td>
                            </table>
                        </td>

                        <td class=" no-wrap pa-2 ma-2 " style="text-align: right;">
                            <strong> S.O.S </strong>
                        </td>
                        <td class="red white--text no-wrap pa-2 ma-2" style="text-align: center; border-radius: 5px;">
                            <strong> 2 </strong>
                        </td>
                    </tr>

                </table>
            </v-flex>
            <v-flex flex xs12 sm12 md3 lg3 class="black pa-2">
                <v-text-field class="white black--text pa-0" style="width:100%;" v-model="searchText" label="Cerca " outline clearable append-icon="search" @input="changedSearch"></v-text-field>
            </v-flex>
        </v-layout>
    </v-footer>
</div>
</template>

<script>
//import AppNavigationVue from '../components/AppNavigation.vue';
import dayjs from 'dayjs';
import Replay1Vue from '../components/Replay1.vue';

export default {
    components: {
        mapDetail: Replay1Vue,
    },
    name: 'BaseMap',
    data() {
        return {
            stato: '_briefing',

            idEvento: 0,
            idAttivita: -1,
            token: null,

            fields: {
                racename: 'VIRTUAL DRONE'
            },
            showMap: false,
            bibList: [],
            moltiplicatore: 1,
            pause: false,

            miniVariant: false,
            listaDevices: [],
            listaPartecipanti: [],
            rightDrawer: false,
            rightDrawerConf: false,
            leftDrawer: false,
            right: true,
            showSnack: false,
            vertical: true,
            multiline: true,
            messaggioSnack: '',
            timeout: 5000,
            colorSnack: 'red',
            searchText: '',

            pois: [],
            tracks: [],
            areas: [],

            isAddPoi: false,

            raceTitle: '',

            deviceMap: {},
            showDevice: false,

            value: 0,
            bufferValue: 100,
            interval: 0,
            pause: false,
            indexTo: -1,

            configuration: undefined,
            raceTime: "--:--:--",

            firstExecute: false,

            listaRil: [],
            elencoIscritti: [],
            itemsF: [],
            filter: 'ATLETA'
        };
    },
    mounted() {
        console.log(this.$route.query.idAttivita);
        console.log(this.$route.query.token);

        var self = this;

        this.idEvento = this.$route.params.raceID;
        this.paramID = this.$route.params.id;

        this.local = this.$route.params.local;

        this.loadMappa();
        this.loadEvento();
    },

    methods: {
        loadMappa() {
            const _url =
                this.getDataURL() +
                'getGPSConfig?idGara=' +
                this.idEvento +
                '&type=' +
                this.paramID;
            console.log(_url)

            this.getRemoteService(_url).then((response) => {
                console.log('GPX>>' + response + '<<');

                const res = JSON.parse(response);

                this.configuration = [];
                let _conf = {
                    id: 1906,
                    descrizione: 'TEST TATA',
                    note: '37bbcffd177744a0adb648c6645ac1f3',
                    cognome: 'TATARANO',
                    nome: 'ALBERTO',
                    data: '2021-01-07',
                    sport: 'RUNNING',
                    idGara: '20200859',
                    pathGpx: '/profilo-icron/31/attivita/IDX2NnztoXVVCAp-e4V3Xg0YDljbmtJwTVCYNy4aWAk=_20200859.gpx',
                    lunghezza: 20375.7,
                    durata: '01:52:41.000',
                    media: '5,32 Min/Km',

                    passo: this.configEvento.unit
                };

                _conf.type = 'track';
                _conf.color = '#FF0000';
                _conf.distance = _conf.lunghezza;

                var points = [];
                const pMax = parseInt(res.puntoMax)
                for (let i = 0; i < pMax; i = i + 10) {
                    const indexP = '' + i;
                    const latLon = res.mappaPunti[indexP].split(",");
                    points.push([parseFloat(latLon[0]), parseFloat(latLon[1])]);
                }
                //_conf.gpx = response;
                _conf.coordinates = points;
                _conf.mappaPoints = res.mappaPunti;
                _conf.puntoMax = pMax;
                this.configuration.push(_conf);

                //this.showMap = true;

                this.execute(this);

            }); //fine
        },

        isAdmin() {
            return this.configEvento !== undefined && this.configEvento.admin !== undefined;
        },

        getDeviceProperty(devId, property) {
            if (this.deviceMap && this.deviceMap[devId]) {
                return this.deviceMap[devId][property];
            }
        },

        //
        //colorONLINE=green:white
        //colorOFFLINE=red:white

        getBatteryColor(property) {
            if (property == undefined) return 'red';
            const val = parseInt(property)
            if (val < 30) return 'red white--text'
            else if (val >= 30 && val <= 50) return 'orange'
            //else if (val > 50 && val <= 65) return 'yellow'
            else return 'green white--text'
        },

        getSOSColor(property) {
            if (property === 'Y') return 'red white--text'
            return '';
        },

        getBatteryStatus(property) {
            if (property == undefined) return 'battery_unknown';
            const val = parseInt(property)
            if (val < 30) return 'battery_alert'
            //else if (val >=30 && val <= 50) return 'battery_6_bar'
            //else if (val > 50 && val <= 65) return 'battery_7_bar'
            else return 'battery_full'
        },

        getStatusColor(property) {
            if (property == undefined) return 'black';
            if (property === 'ONLINE') return 'green white--text'
            else if (property === 'OFFLINE') return 'red white--text'
            //else if (val > 50 && val <= 65) return 'yellow'
            else return 'green white--text'
        },

        loadEvento() {
            this.listaIntermedi = [];
            this.elencoIscritti = [];

            console.log(this.idEvento);
            const _url =
                this.getDataURL() +
                'getFile?idGara=' +
                this.idEvento +
                '&fileName=remoteTrackConfiguration' +
                this.idEvento +
                '_' +
                this.paramID +
                '.txt';
            //  if (this.local) _url = "/local/"+ this.idEvento+"/localLiveConfiguration" + this.idEvento + "_" + this.paramID + ".csv";
            console.log(_url);
            this.getRemoteService(_url).then((response) => {
                console.log('>>' + response + '<<');
                if (response !== '') {
                    this.configRace(response);
                } else {
                    alert('Evento non configurato.');
                }
            }); //fine
        },

        configRace(response) {
            this.configEvento = this.properties2Object(response);
            this.configOK = true;

            if (this.local !== undefined) {
                const toks = this.local.split(',');
                toks.forEach((tok) => {
                    if (tok.indexOf('=') !== -1) {
                        const keyval = tok.split('=');
                        this.configEvento[keyval[0]] = this.normalize(
                            keyval[1]
                        );
                    }
                });
            }

            console.log('CERCA POI');
            for (let i = 1; i < 100; i++) {
                //alert(this.configEvento['split' + i]) ;
                let _poi = this.configEvento['poi' + i];
                if (_poi !== undefined) {
                    this.configEvento.numPoi = i;

                    console.log('POI:' + _poi);

                    let _myPoi = {
                        id: i
                    };

                    const toks = _poi.split(';');
                    toks.forEach((tok) => {
                        if (tok.indexOf('=') !== -1) {
                            const keyval = tok.split('=');
                            const value = this.normalize(keyval[1]);
                            _myPoi[keyval[0]] = value;
                        }
                    });

                    this.pois.push(_myPoi);
                    console.log(_myPoi);
                } else {
                    break;
                }
            }

            //alert(this.configEvento.numSplit);

            //this.configEvento.numSplit = parseInt(this.configEvento.numSplit);
            if (this.configEvento.timeFormat == undefined)
                this.configEvento.timeFormat = 'HH:mm:ss';
            if (this.configEvento.gapFormat == undefined)
                this.configEvento.gapFormat = 'HH:mm:ss';

            this.color =
                this.configEvento.color !== undefined ?
                this.configEvento.color :
                'red';
            this.baseColor =
                this.configEvento.baseColor !== undefined ?
                this.configEvento.baseColor :
                this.baseColor;
            this.showGap =
                this.configEvento.showGap !== undefined &&
                this.configEvento.showGap == 'true' ?
                true :
                false;
            this.numFrac =
                this.configEvento.numFrac !== undefined ?
                parseInt(this.configEvento.numFrac) :
                1;

            this.showDivisione =
                this.configEvento.showDivisione !== undefined &&
                this.configEvento.showDivisione == 'true' ?
                true :
                false;
            this.showPosAssoluta =
                this.configEvento.showPosAssoluta !== undefined &&
                this.configEvento.showPosAssoluta == 'true' ?
                true :
                false;
            this.showPosDivisione =
                this.configEvento.showPosDivisione !== undefined &&
                this.configEvento.showPosDivisione == 'true' ?
                true :
                false;
            this.showPosMF =
                this.configEvento.showPosMF !== undefined &&
                this.configEvento.showPosMF == 'true' ?
                true :
                false;
            this.showPettorale =
                this.configEvento.showPettorale !== undefined &&
                this.configEvento.showPettorale == 'true' ?
                true :
                false;
            this.showNazione =
                this.configEvento.showNazione !== undefined &&
                this.configEvento.showNazione == 'true' ?
                true :
                false;
            this.showAtleta =
                this.configEvento.showAtleta !== undefined &&
                this.configEvento.showAtleta == 'true' ?
                true :
                false;
            this.showCategoria =
                this.configEvento.showCategoria !== undefined &&
                this.configEvento.showCategoria == 'true' ?
                true :
                false;
            this.showPosCategoria =
                this.configEvento.showPosCategoria !== undefined &&
                this.configEvento.showPosCategoria == 'true' ?
                true :
                false;
            this.showSquadra =
                this.configEvento.showSquadra !== undefined &&
                this.configEvento.showSquadra == 'true' ?
                true :
                false;
            this.showTempo =
                this.configEvento.showTempo !== undefined &&
                this.configEvento.showTempo == 'true' ?
                true :
                false;
            this.showMetri =
                this.configEvento.showMetri !== undefined &&
                this.configEvento.showMetri == 'true' ?
                true :
                false;
            this.showBatteria =
                this.configEvento.showBatteria !== undefined &&
                this.configEvento.showBatteria == 'true' ?
                true :
                false;

            this.refreshPage =
                this.configEvento.refreshPage !== undefined ?
                parseInt(this.configEvento.refreshPage) * 1000 :
                300000;
            this.refreshData =
                this.configEvento.refreshData !== undefined ?
                parseInt(this.configEvento.refreshData) * 1000 :
                60000;

            this.raceTitle = this.configEvento['raceTitle'];

            const _url =
                this.getDataURL() +
                'getFile?idGara=' +
                this.idEvento +
                '&fileName=remoteTrackParticipants' +
                this.idEvento +
                '_' +
                this.paramID +
                '.csv';
            //if (this.local) _url = "/local/"+ this.idEvento+ "/localLiveParticipants" + this.idEvento + "_" + this.paramID + ".csv";
            this.getRemoteService(_url).then((response) => {
                this.elencoIscritti = this.csvJSON(response).filter((elem) => {
                    let res = true;
                    if (this.configEvento.filtroCategorie) {
                        const found = this.configEvento.filtroCategorie
                            .split(',')
                            .find((element) => element === elem.categoria);
                        res = found !== undefined;
                    }
                    if (res) {
                        if (this.configEvento.filtroDivisioni) {
                            //console.log("FILTRO DIVISIONI ATTIVO:" + this.configEvento.filtroDivisioni)
                            const found = this.configEvento.filtroDivisioni
                                .split(',')
                                .find((element) => element === elem.divisione);
                            res = found !== undefined;
                        }
                    }
                    if (this.configEvento.filtroPettorale !== undefined) {
                        const listaPett =
                            this.configEvento.filtroPettorale.split(',');
                        const found = listaPett.find(
                            (element) => element === elem.pett
                        );
                        res = found !== undefined;
                    }

                    return res;
                });

                this.mappaDivisioni = {};
                this.mappaMetriDivisioni = {};
                this.listaDivisioni = [];
                this.listaCategorie = [];
                let mappaCategorie = {};
                let mappaNazioni = {};

                this.listaDivisioni.push('TUTTE');
                this.listaCategorie.push('TUTTE');

                this.elencoIscritti.forEach((elem) => {
                    elem.showMarker = true;

                    if (elem.nazione && elem.nazione.length > 3) {
                        elem.nazione = elem.nazione
                            .substring(0, 3)
                            .toLowerCase();
                    } else if (
                        elem.nazione === undefined ||
                        elem.nazione === ''
                    ) {
                        elem.nazione = 'ita';
                    }
                    elem.nazione = this.normalizeNaz(elem.nazione);
                    mappaNazioni[elem['nazione']] = elem['nazione'];

                    if (elem['partenza onda'] != undefined) {
                        elem.batteria = elem['partenza onda'];
                    }

                    if (elem.pettorale !== undefined) {
                        elem.pett = elem.pettorale;
                    } else if (elem.p !== undefined) {
                        elem.pett = elem.p;
                    } else if (elem.dorsale !== undefined) {
                        elem.pett = elem.dorsale;
                    } else if (elem.dors !== undefined) {
                        elem.pett = elem.dors;
                    }

                    if (elem['deviceid'] != undefined) {
                        if (elem['deviceid'].indexOf('-') !== -1) {
                            let chips = elem['deviceid'].split('-');
                            chips.forEach((chip) => {
                                this.deviceMap[chip] = elem;
                            });
                        } else {
                            this.deviceMap[elem['deviceid']] = elem;
                        }
                    }

                    elem.posIndex = 0;
                    elem.speed = 0;

                    //this.deviceMap[elem['pett']] = elem; // aggiungo anche la possibilità di usare il pettorale come chip

                    const _cc = elem['sesso'] + ' - ' + elem['categoria'];
                    mappaCategorie[_cc] = elem['categoria'];
                });

                window.deviceMap = this.deviceMap;
                console.log(window.deviceMap);

                this.bibList = this.elencoIscritti.map((elem) => elem.pett);

                this.listaCategorie = Object.keys(mappaCategorie);
                if (this.listaCategorie.length > 1) {}
                //  }
                this.listaCategorie.sort();

                this.mostraNazione = Object.keys(mappaNazioni).length > 1;
                this.listaNazioni = Object.keys(mappaNazioni);
                this.listaNazioni.sort();
                this.listaNazioni.unshift('TUTTE');

                this.itemsF = this.filteredList()

                this.showDevice = true;

                //this.refresh(this);
                this.myInterval = setInterval(
                    this.refresh,
                    this.refreshData,
                    this
                );

                this.myIntervalBar = setInterval(this.refreshBar, 1000, this);
                setTimeout(this.refreshAll, this.refreshPage);
            });
        },

        refreshAll() {
            clearInterval(this.myInterval);
            clearInterval(this.myIntervalBar);
            //alert("Riavvio pagina")
            window.location.reload();
        },

        refresh: function (self) {
            //if (self.pause) return;
            self.currentIndex = 1;
            self.value = 0;
            self.numRilevamentiStep = 0;
            self.execute(self);
        },

        run() {
            this.pause = false;
        },

        getTempo(guntime, tempoRil) {
            var utc = require('dayjs/plugin/utc')
            dayjs.extend(utc);

            const tt0 = this.normalizzaTS(guntime);
            const tt1 = this.normalizzaTS(tempoRil);

            //console.log("getTempo: " + tt0+" "+ tt1);

            const t0 = dayjs(this.getIsoDate(tt0)).utc();
            const t1 = dayjs(this.getIsoDate(tt1)).utc();

            var duration = (t1.diff(t0));
            let result = dayjs(duration).utc().format(this.configEvento.timeFormat);

            //console.log(">getTempo: " +result);

            if (result === 'Invalid Date') return tempoRil;

            return result;
        },

        refreshBar: function (self) {

            const now = dayjs(new Date()).format('HH:mm:ss');
            this.raceTime = this.diffTime(now, this.configEvento.gunTime)

            if (self.pause) return;
            if (self.value == undefined) self.value = 0;
            // console.log("refreshBar :" + self.value)
            self.value += 100 / (self.refreshData / 1000);
            //console.log(self.value);
            if (self.value > 100) self.value = 0;

            // const now = dayjs(new Date()).format('HH:mm:ss');
            //this.raceTime = this.diffTime(now, this.configEvento.gunTime);
        },

        execute(self) {
            const _url =
                this.getDataURL() +
                'getGPSPositions?idGara=' +
                this.idEvento +
                '&type=' +
                this.paramID;
            console.log(_url)

            self.getRemoteService(_url)
                .then((response) => {
                    if (response.length > 0) {
                        console.log(response);
                        let listaEnriched = [];
                        //let lista = this.csvJSON(response);

                        let lista = JSON.parse(response).listaRil;

                        lista.forEach((_liveTrack) => {
                            let p = self.deviceMap[_liveTrack.deviceid];
                            if (p !== undefined) {
                                const cognome = p.cognome.substring(0, 3);
                                _liveTrack['nomeShort'] =
                                    p.pett +
                                    ' ' +
                                    cognome;
                                //const nome =  this.deviceMap[_liveTrack.deviceid].nome.substring(0,1);
                                _liveTrack['descrizione'] =
                                    p.cognome +
                                    ' ' +
                                   p.nome +
                                    ' #' +
                                    p.pett +
                                    ' - ' +
                                     _liveTrack.passo;

                                _liveTrack['km'] = parseInt(_liveTrack.metri / 1000);

                                //_liveTrack.speed = parseFloat(_liveTrack.lastspeed);
                                //console.log( _liveTrack.speed);

                                //_liveTrack.speed = parseFloat(_liveTrack.speed) + (2 * Math.random());

                                let merged = {
                                    ...this.deviceMap[_liveTrack.deviceid],
                                    ..._liveTrack,
                                };
                                listaEnriched.push(merged)
                                self.deviceMap[_liveTrack.deviceid] = merged;

                                // console.log("MERGED>" + JSON.stringify(merged))
                            } else
                                console.log("Device sconosciuto")

                        });

                        let elencoAgg = []
                        this.elencoIscritti.forEach(elem => {
                            elem = self.deviceMap[elem.deviceid];
                            elencoAgg.push(elem);
                        });
                        this.elencoIscritti = elencoAgg;

                        this.itemsF = this.filteredList()

                        this.listaRil = listaEnriched
                        this.$root.$emit('command', {
                            command: {
                                id: 'updateTracks'
                            },
                        });
                        this.showMap = true;

                    }
                })
                .catch((error) => {
                    console.log('Errore ' + error);
                });
        },

        showHideMarker(p) {
            p.showMarker = !p.showMarker;
            self.deviceMap[p.deviceid].showMarker = p.showMarker;
            this.$root.$emit('command', {
                command: {
                    id: 'updateAllMarkers',
                    participants: [self.deviceMap[p.deviceid]],
                },
            });
        },

        hideAllMarkers() {
            let listaEnriched = [];
            this.elencoIscritti.forEach((p) => {
                p.showMarker = false;
                self.deviceMap[p.deviceid].showMarker = p.showMarker;
                listaEnriched.push(self.deviceMap[p.deviceid]);
            });
            this.$root.$emit('command', {
                command: {
                    id: 'updateAllMarkers',
                    participants: listaEnriched,
                },
            });
        },

        showAllMarkers() {
            let listaEnriched = [];
            this.elencoIscritti.forEach((p) => {
                p.showMarker = true;
                self.deviceMap[p.deviceid].showMarker = p.showMarker;
                listaEnriched.push(self.deviceMap[p.deviceid]);
            });
            this.$root.$emit('command', {
                command: {
                    id: 'updateAllMarkers',
                    participants: listaEnriched,
                },
            });
        },

        loadAttivita() {
            this.getAttivita(this.idAttivita, this.token).then((rowData) => {
                console.log(rowData);

                rowData.elencoAttivita[0].type = 'track';
                rowData.elencoAttivita[0].color = '#EEFF41';
                rowData.elencoAttivita[0].distance =
                    rowData.elencoAttivita[0].lunghezza;
                this.configuration = [rowData.elencoAttivita[0]];
                this.fields.racename = this.configuration[0].descrizione;

                this.tracks = [];
                this.tracks.push(this.configuration[0]);
                /* this.tracks = this.getTracks();
                this.setFields();*/
                this.showMap = true;
                /*this.configuration = this.csvJSON(rowData);
                console.log(this.configuration);

                this.pois = this.getPois();
                this.areas = this.getAreas();

                */
            });
        },

        loadConfiguration(eventoId) {
            this.getConfiguration(eventoId).then((rowData) => {
                console.log(rowData);
                this.configuration = this.csvJSON(rowData);
                console.log(this.configuration);

                this.tracks = this.getTracks();
                this.pois = this.getPois();
                this.areas = this.getAreas();

                this.setFields();

                this.showMap = true;
            });
        },
        setFields() {
            if (this.configuration) {
                this.configuration
                    .filter((elem) => elem.type == 'field')
                    .forEach((element) => {
                        this.fields[element.id] = element.descrizione;
                    });
            }
        },
        getTracks() {
            if (this.configuration) {
                return this.configuration.filter(
                    (elem) => elem.type == 'track'
                );
            } else {
                return [];
            }
        },
        getPois() {
            console.log('POI>');
            if (this.configuration) {
                return this.configuration.filter((elem) => elem.type == 'poi');
            } else {
                return [];
            }
        },
        getAreas() {
            if (this.configuration) {
                return this.configuration.filter((elem) => elem.type == 'area');
            } else {
                return [];
            }
        },
        fromMap(param) {
            console.log('FROM MAP:' + JSON.stringify(param));
            this.configuration = this.configuration.map(
                (obj) => [param.route].find((o) => o.id === obj.id) || obj
            );
            this.tracks = this.getTracks();
        },
        addNewMarker({
            marker
        }) {
            console.log('ADD>' + JSON.stringify(marker));
            this.configuration.push(marker);

            this.tracks = this.getTracks();
            this.pois = this.getPois();
            this.areas = this.getAreas();

            // var audio = new Audio(require('../assets/audio/alarm.mp3'));
            // audio.play();
        },
        loadDevices(eventoId) {
            this.getElencoDevices(eventoId).then((rowData) => {
                //console.log(rowData);
                this.listaDevices = this.csvJSON(rowData);
                console.log(this.listaDevices);
            });
        },
        loadPartecipanti(eventoId) {
            this.getElencoDevicesPartecipanti(eventoId).then((rowData) => {
                //console.log(rowData);
                this.listaPartecipanti = this.csvJSON(rowData);
                console.log(this.listaPartecipanti);
                this.bibList = this.listaPartecipanti.map((elem) => elem.pett);
            });
        },
        filterTipo( prop ){
            this.searchText = '';
           this.filter = prop;
           this.itemsF = this.filteredList()
        },
        filteredList() {
            var listaSearch = this.elencoIscritti.filter( p => {
                if (this.filter == 'WARNING') {
                    return (p.sos === 'Y' || p.ontrack === 'N'|| p.battery < 30 || p.stato === 'OFFLINE')
                } else if (this.filter == 'SOS') {
                    return (p.sos === 'Y' )
                } else  {
                    return p.tipo === this.filter
                }
            });

            console.log("LISTA:" + listaSearch.length )

            if (this.searchText !== '' && this.searchText != null) {
                listaSearch =listaSearch.filter((p) => {
                    let res =
                        p != null &&
                        p.cognome != null &&
                        p.cognome.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;

                    let res2 =
                        p != null &&
                        p.pett != null &&
                        p.pett == this.searchText;

                    let resTot = ( res  || res2 );
                    return resTot;
                });
            }

           return listaSearch;
            
        },

        changedSearch(event) {
            console.log('Changed:' + event);
            this.searchText = event;

            this.itemsF = this.filteredList();
        },

        displaySnack(param) {
            console.log(param);
            this.messaggioSnack =
                'Km. ' +
                param.banner.coordinates +
                ' - ' +
                param.banner.descrizione;
            this.showSnack = true;
        },

        clickMarker(param) {
            console.log(param);
            let p = this.listaPartecipanti.find(
                (elem) => elem.pett == param.id
            );
            this.messaggioSnack = param.id + ' ' + p.cognome + ' ' + p.nome;
            this.showSnack = true;
        },
        details(device) {
            console.log(device);
            if (device.bgcolor) this.colorSnack = device.bgcolor;
            else this.colorSnack = 'black';
            this.messaggioSnack =
                device.descrizione +
                '\n' +
                device.contatto +
                ' ' +
                device.riferimenti;
            this.showSnack = true;
        },

        confDetails(config) {
            if (config.color) this.colorSnack = config.color;
            else this.colorSnack = 'black';
            this.messaggioSnack = config.descrizione;

            this.$root.$emit('command', {
                command: {
                    id: 'gotoPlace',
                    place: config
                },
            });
            this.showSnack = true;
        },
        helicopter(config) {
            this.$root.$emit('command', {
                command: {
                    id: 'helicopter',
                    place: config
                },
            });
        },
        centerTo(config) {
            this.$root.$emit('command', {
                command: {
                    id: 'centerTo',
                    place: this.deviceMap[config.deviceid].lonLat,
                },
            });
        },
        readerClass(device) {
            var styleBase = 'mt-2 ml-2 mr-2 pa-1 markerBar ';
            styleBase += ' markerBarStatus_' + device.stato;
            return styleBase;
        },
        readerStyle(device) {
            var styleBase = '';
            if (device.color) styleBase += ' color: ' + device.color + '; ';
            else styleBase += ' color: white;';
            if (device.bgcolor)
                styleBase += ' background-color: ' + device.bgcolor + '; ';
            else styleBase += ' background-color: black;';
            return styleBase;
        },
        participantClass(device) {
            var styleBase = ' ma-1 pa-1 markerPartecipante ';
            if (device.stato == undefined || device.stato == '')
                device.stato = 'offline';
            styleBase += ' markerStatus_' + device.stato;
            return styleBase;
        },
        participantStyle(device) {
            var styleBase = '';
            //styleBase += ' color: orange;';
            /* if (device.color) styleBase += ' color: ' + device.color + '; ';
            else 
            if (device.bgcolor)
                styleBase += ' background-color: ' + device.bgcolor + '; ';
            else styleBase += ' background-color: black;';*/
            return styleBase;
        },
        confClass(device) {
            var styleBase = 'mt-2 ml-2 mr-2 pa-1 markerConfig ';
            return styleBase;
        },
        confStyle(device) {
            var styleBase = '';
            if (device.color)
                styleBase += '  border-left: 10px solid ' + device.color + '; ';
            return styleBase;
        },
        forward(x) {
            console.log('Moltiplicatore:' + x);
            this.moltiplicatore = x;
        },
        pauseBtn() {
            this.pause = true;
            window._pause = this.pause;
        },
        playBtn() {
            this.pause = false;
            window._pause = this.pause;
        },

        getColor(columnName, valore) {

            let colore = this.configEvento[columnName + valore];
            if (colore === undefined) {
                colore = this.configEvento[columnName];
                if (colore === undefined) {
                    colore = this.configEvento.baseColor;
                }
            }
            if (colore !== undefined) {
                if (colore.indexOf(":") !== -1) {
                    return colore.split(":")[0] + ' ' + colore.split(":")[1] + '--text '
                } else {
                    return colore + ' white--text '
                }
            }
            return 'white black--text '
        },

        getScales() {
            // All the maths to work chart co ordinates and woring out Axis
            var parseDate = d3.timeParse('%m-%d-%Y');

            this.data.forEach(function (d) {
                d.date = parseDate(d.day);
            });

            const x = d3
                .scaleTime()
                .domain(
                    d3.extent(this.data, function (d) {
                        return d.date;
                    })
                )
                .rangeRound([0, this.chartDefaults.width - 100]);
            const y = d3
                .scaleLinear()
                .domain([
                    0,
                    d3.max(this.data, function (d) {
                        return d.count + 100;
                    }),
                ])
                .range([this.chartDefaults.height, 0]);
            d3.axisBottom().scale(x);
            d3.axisLeft().scale(y);

            //Key funtions to draw X-axis,YAxis and the grid. All uses component axis
            //play around with time format to get it to display as you want : d3.timeFormat("%b-%d")
            var xAxis = d3
                .axisBottom()
                .scale(x)
                .tickFormat(d3.timeFormat('%b'))
                .tickValues(
                    this.data
                    .map(function (d, i) {
                        if (i > 0) {
                            return d.date;
                        }
                        return false;
                    })
                    .splice(1)
                )
                .ticks(4);

            var yAxis = d3.axisLeft().scale(y).ticks(5);
            var yGrid = d3
                .axisLeft()
                .scale(y)
                .tickSize(-(this.chartDefaults.width - 100), 0, 0)
                .tickFormat('');
            // Return the key calculations and functions to draw the chart
            return {
                x,
                y,
                xAxis,
                yAxis,
                yGrid,
            };
        },
        getTrnsx(chartDefaults) {
            //works out translate value in realtive to dynamic height
            const t = 'translate(0,' + this.chartDefaults.height + ')';
            return t;
        },
        calculatePath() {
            //Get key calculation funtions to draw chart , Ie scale, axis mapping and plotting
            const scale = this.getScales();
            // Define calcultion to draw chart
            const path = d3
                .line()
                .x((d) => {
                    return scale.x(d.date);
                })
                .y((d) => {
                    return scale.y(d.count);
                })
                .curve(d3.curveCardinal);

            // draw line then this.line is injected into the template
            this.line = path(this.data);
        },
    },
};
</script>

<style>
.markerBar {
    border: 1px solid white;
    width: 100%;
    height: 20px;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
    font-size: 14px;
    height: 100%;
}

.markerBarStatus_online {
    border-right: 10px solid green;
}

.markerBarStatus_offline {
    border-right: 10px solid orange;
}

.markerPartecipante {
    background-color: #263238;
    color: white;
    border: 1px solid grey;
    width: 100%;
    border-radius: 5px;
    cursor: pointer;
    text-align: left;
    font-size: 14px;
    height: 100%;
}

.markerStatus_online {
    border-left: 10px solid green;
}

.markerStatus_offline {
    border-left: 10px solid red;
}

.markerConfig {
    background-color: #263238;
    color: white;
    border: 1px solid grey;
    width: 100%;
    border-radius: 5px;
    text-align: left;
    font-size: 14px;
    height: 100%;
}

table.v-table tbody td,
table.v-table tbody th {
    height: 25px
}
</style>
